import { FieldsSerializer } from 'Helpers'
import { ORDER_DIRECTION } from 'Src/constants/Global'
import { FieldNames } from 'Src/constants/FieldNames'

// TODO: NC-5191 - do something cool about RequestParams type
export class RequestParams implements Record<string, any> {
	public page: number
	public per_page: number
	public query?: string
	public order_direction?: ORDER_DIRECTION
	public order_by?: string
	public only?: string

	public constructor(page?: number, per_page?: number, query?: string | null, fields?: any) {
		if (fields) {
			const serializeFields = FieldsSerializer.serializeFields(fields)
			Object.keys(serializeFields).forEach((key: string): void => {
				this[key] = serializeFields[key]
			})
		}

		this.page = page || 1
		this.per_page = per_page || 30
		if (query) this.query = query
	}
	[x: string]: any
	public get params(): any {
		const { page, per_page, query, order_direction, order_by, only, ...allParams } = this // eslint-disable-line
		return allParams
	}

	public get(name: FieldNames): any {
		if (this?.params) {
			return this.params[name]
		}
		return undefined
	}

	public get onlyTotalEntries(): RequestParams {
		this.only = 'total_entries'
		return this
	}

	public get withoutTotalEntries(): RequestParams {
		this.only = 'current_page,entries,per_page'
		return this
	}
	public get withTotalPages(): RequestParams {
		this.only = 'current_page,entries,per_page,total_entries'
		return this
	}
}
